import type { JSX } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAppAuth'

export const WelcomePage = (): JSX.Element => {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Authenticated users go to dashboard, everyone else goes to login
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />
}
